/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';

export const useMediaMax = (breakpoint: number, minusOne = true): boolean => {
  const query = `(max-width: ${breakpoint - (minusOne ? 1 : 0)}px)`;
  const mediaQueryList = window.matchMedia(query);

  // State and setter for matched value
  const [matches, setMatches] = useState(mediaQueryList.matches);

  useEffect(() => {
    const handler = () => {
      setMatches(mediaQueryList.matches);
    };
    mediaQueryList.addEventListener('change', handler, { passive: true });
    return () => {
      mediaQueryList.removeEventListener('change', handler);
    };
  }, []);

  return matches;
};
